module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "widget clock",
    attrs: {
      "id": "taipei",
      "data-timezone": "+8"
    }
  }, [_c('div', {
    staticClass: "hand seconds"
  }), _vm._v(" "), _c('div', {
    staticClass: "hand minutes"
  }), _vm._v(" "), _c('div', {
    staticClass: "hand hours"
  }), _vm._v(" "), _c('div', {
    staticClass: "hand-cap"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd62ebb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Clock.vue
// module id = 1547
// module chunks = 1